import {Injectable} from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import {Configuration} from "../model/configuration";
import {TranslocoService} from "@ngneat/transloco";
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  private mapbox = mapboxgl;
  private style: string = `mapbox://styles/mapbox/streets-v11`;

  private language: string;


  constructor(private i18n: TranslocoService) {
    this.mapbox.accessToken = 'pk.eyJ1IjoiamF2aWVybWYiLCJhIjoiUFZvSk5qRSJ9.VW5dRmokGm3gRcc_5Afs2g';
  }

  buildMap(zoom: number, latitude: number, longitude: number, container?: string, controls: boolean = true,
           configuration: Configuration = null, style: string = ''): mapboxgl.Map {
    let map;
    if (configuration != null) {
      map = new mapboxgl.Map({
        container: container || 'map',
        style: style !== '' ? style : this.style,
        zoom: configuration.zoom,
        center: [longitude, latitude],
        cluster: true,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
        pitch: configuration.pitch,
        bearing: configuration.bearing,
        maxPitch: 68,
        attributionControl: false
      });
    } else {
      map = new mapboxgl.Map({
        container: container || 'map',
        style: style !== '' ? style : this.style,
        zoom: zoom,
        center: [longitude, latitude],
        cluster: true,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
        maxPitch: 68,
        attributionControl: false
      });
    }
    if (controls) {
      map.addControl(new mapboxgl.NavigationControl());
      map.addControl(new mapboxgl.FullscreenControl());
    }
    this.buildResizeObserver(map, container ?? 'map');
    return map;
  }

  private buildResizeObserver(map: mapboxgl.Map, containerId: string): void {
    let resizeTimeout;
    new ResizeObserver(() => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => map.resize(), 50);
    }).observe(document.getElementById(containerId));
  }

  buildStaticPulsingDot(map: mapboxgl.Map, latitude, longitude): mapboxgl.Marker {
    const parent = document.createElement('div');
    parent.className = 'pulse-box';
    const child = document.createElement('div');
    child.className = 'pulse-css';
    parent.append(child);

    return new mapboxgl.Marker(parent)
      .setLngLat([longitude, latitude])
      .addTo(map);
  }

  buildGeocoder(map: mapboxgl.Map): void {
    this.language = this.i18n.getActiveLang();
    this.i18n.selectTranslate('common.search').subscribe(() => {
      map.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          language: this.language,
          mapboxgl: mapboxgl,
          marker: false,
          placeholder: this.i18n.translate('common.search')
        }),
        'top-left'
      );
    });
  }

  getGeocoder(): MapboxGeocoder {
    return new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      language: this.language,
      placeholder: this.i18n.translate('common.search'),
      types: 'place'
    });
  }

}
